import { normalReqest, uploadRequest } from "./http";

export const loginRequest = (params) =>
  normalReqest("/session", {
    method: "POST",
    data: params,
  });
export const logout = () => normalReqest('/logout', { method: "POST" });
// 获取baseUrl
export const getBaseUrl = () => normalReqest('/baseUrl1');
export const userInfo = () => normalReqest('/userInfo')
export const getPermission = () => normalReqest('/permission')
export const searchDict = () => normalReqest('/file/assets/dictionary.json', { method: "GET" });
//当前负责人
export const getResponsible = () => normalReqest('/file/assets/mediator.json', { method: "GET" });

// 短信验证
export const vcode = params =>
  normalReqest('/vcode ', {
    method: "POST",
    data: params
  })

export const changePassword = (params) =>
  normalReqest("/changePassword", {
    method: "POST",
    data: params,
  });

//获取列表

export const getList = (param, path, page, pageSize) =>
  normalReqest(`${path}?pageSize=${pageSize}&page=${page}`, {
    method: "GET",
    params: { data: param }
  })

//批量下载表格
export const batchDownload = (params, path) => normalReqest(`${path}/batchDownload?data=${params}`);

// 获取状态列表
export const getStatusDict = (path, dictType) => normalReqest(`${path}/${dictType}`);

//获取 审判员书记员 信息
export const getMember = (path) => normalReqest(`${path}/roleList`);
//待调解分案批量调解获取组别，调解员信息
export const getBatchMember = (path) => normalReqest(`${path}/roleLists`);

// 批量操作
export const handleBatch = (param, path, name) => normalReqest(`${path}/${name}`, {
  method: 'POST',
  data: param
})
// 获取详情
export const getDetail = (path, systemNum, cardType) => normalReqest(`${path}/${cardType}/${systemNum}`);
// 获取结案登记案由
export const findClosedReason = path => normalReqest(`${path}/findClosedReason`);
//结案登记
export const closingRegt = (params, path) => normalReqest(`${path}/closingRegt`, {
  method: 'POST',
  data: params
})

//
// 更新调解状态参数
export const setMediationParam = (params, path) => normalReqest(`${path}`, {
  method: "POST",
  data: params,
});

//打印
export const pdfConversion = (params, systemNum, path) => normalReqest(`${path}/pdfConversion/${systemNum}`, {
  method: "POST",
  data: params,
})

//文书审核
export const checkRes = (params, resID, path) => normalReqest(`${path}/checkRes/${resID}`, {
  method: "POST",
  data: params,
})
// 文书删除
export const deleteFile = (url, path) => normalReqest(`${path}/deleteRes?path=${url}`, { method: 'DELETE' });

// 电子卷宗上传
export const getId = (params, path, systemNum) => normalReqest(`${path}/resId`, {
  method: "POST",
  data: {
    systemNum,
    fileName: params.file.name,
    resType: params.resType,
    uploadTime: params.uploadTime,
    mediationInfoId:params.mediationInfoId
  }
});

export const fileUpload = (params, path, resId) => uploadRequest(`${path}/uploadFile/${resId}`, {
  method: "POST",
  data: params
})

export const postDetailSubmit = (url, data) => normalReqest(`${url}`, { method: "POST", data });
//新增回款登记
export const postPaymentSubmit = (url, data) => normalReqest(`${url}/paymentRegisterSubmitResId`, { method: "POST", data });
export const postPaymentFile = (url, resID, file) => normalReqest(`${url}/paymentRegisterSubmit/${resID}`, {method:'POST',data:file}
);
export const postPaymentSubmitUpdate = (url, data) => normalReqest(`${url}/paymentRegisterUpdateResId`, { method: "POST", data });
//新增自动协查找人
export const postAutomaticSubmit = (url, data) => normalReqest(`${url}`, { method: "POST", data });
export const getLostPhone = (path, params) => normalReqest(`${path}/getMiddleNumber/${params.repairId}`);

// 批量下载
export const downloadEle = (path, data) => normalReqest(`${path}/compress`, {
  method: "POST",
  data,
});
// 协商还款申请
export const submitRepayment = (path, data) => normalReqest(`${path}/submitApplyNegRepay`, {
  method: "POST",
  data,
});
// 协商还款申请 - 上传附件
export const uploadAnnexes = (path, formData) => uploadRequest(`${path}/uploadAnnexes`, {
  method: "POST",
  data: formData,
});

//获取电话号码
export const getPhoneNumber = (path, systemNum) => normalReqest(`${path}/mediationInfo/getPhoneNumber/${systemNum}`)

//获取调解时间
export const mediationTime = (params, path) => normalReqest(`${path}/getMediationTime`, {
  method: "POST",
  data: params,
})

//调解登记
export const mediationRegister = (params, path) => normalReqest(`${path}/mediationRegister`, {
  method: "POST",
  data: params,
})

//修改调解登记
export const mediationRegisterUpdate = (params, path) => normalReqest(`${path}/updateMediationRegister`, {
  method: "POST",
  data: params,
})

//录音上传
export const uploadMediationRecord = (params, path) => normalReqest(`${path}/uploadMediationRecord`, {
  method: "POST",
  data: params,
})

// 拨打电话(七陌)
export const callDefendant = (params, path) => normalReqest(`${path}/mediationInfoCall`, {
  method: "POST",
  data: params,
})
// 天津移动
export const callWeygo = (params, path) => normalReqest(`${path}/weygocall`, {
  method: "POST",
  data: params,
})
//获取电话平台类型(七陌，天津移动)
export const getCallType = (path) => normalReqest(`${path}/callProvider`)


// 发送闪信
export const sendFlashLetter = (params, path) => normalReqest(`${path}/sendFlashSms`, {
  method: "POST",
  data: params,
})

// 发送账密短信
export const sendMsg = (path, params, systemNum) => normalReqest(`${path}/sendDefendantAccountSms/${systemNum}`, {
  method: "POST",
  data: params,
})

// 获取调解方案信息
export const getDocCheckInfo = (path, systemNum) => normalReqest(`${path}/getDocCheckInfo/${systemNum}`)

// 推送调解方案确认
export const sendMediationDoc = (path, params, systemNum) => normalReqest(`${path}/mediationSend`, {
  method: "POST",
  data: params,
})

// 多人调解获取场次
export const getMediationSession = (path, params) => normalReqest(`${path}/mediationBatchList`, {
  method: "GET",
  params,
})

// 批量开启在线调解
export const postMediationBatch = (path, params) => normalReqest(`${path}/startMediationBatch`, {
  method: "POST",
  data: params,
})

//签名
export const getSignature = (params) => normalReqest(`/signOrSeal`, {
  method: "POST",
  data: params,
});

export const getSignatureID = (fileName) => normalReqest(`/signatureID`, {
  method: "POST",
  data: { fileName }
});
export const postSignature = (file, resID) => uploadRequest(`/signature/${resID}`, {
  method: "POST",
  data: file,
});
export const postPayment = (path, params) => normalReqest(`${path}/paymentRegisterSubmitResId`, { method: "POST",body:params });

//获取自动协查找人来源
export const getLostProviderTypeDict = (path) => normalReqest(`${path}/lostProviderTypeDict`)